import React, {Component} from 'react';
import firebase from 'firebase';

const database=firebase.database();


class UsuariosRegistrados extends Component{
	
	
	constructor(props){
		super(props);
		this.state={
			
		}
		
		this.usuariosRef=database.ref().child('Clientes');
		
	}
	
	
	componentDidMount(){
		
		this.usuariosRef.once('value',this.gotData,this.errData);
		
	}
	
	
	gotData=(data)=>{
		
		
		
		
		
	}
	errData=(err)=>{
		
		
	}
	
	
	render(){
		
		return(
		
			<h1>Usuarios registrados</h1>
		)		
	}
}

export default UsuariosRegistrados;


// WEBPACK FOOTER //
// ./src/Components/Reportes/UsuariosRegistrados.jsx